require('./prtv-depot-facture.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';
import ListeAntennisteRepository from '../../../../repositories/liste-antenniste.repository';
import { MAXIMUM_DISTANCE, MINUMUM_DISTANCE, DISTANCE_STEP } from '../../model';
import PdfUtil from '../../../../utils/pdf.util';
import { EMAIL_PATTERN, TELEPHONE_PATTERN } from '../../../../utils/pattern.util';
export default class PrtvDepotFactureComponent {
  constructor() {
    this.controller = PrtvDepotFactureController;
    this.template = require('./prtv-depot-facture.html');
  }
}

// @ngInject
class PrtvDepotFactureController {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.allAntennistesCalled = false;
    this.rayonMax = MINUMUM_DISTANCE;
    this.lastRayon = 0;
    this.dernierChangementRayon = new Date();
    this.nbOfAntennistes = 0;
    this.loadingWebService = false;
    this.data = {
      denomination: '',
      nomContact: '',
      adresseContact: '',
      telContact: '',
      isFactureOk: false,
      factureFile: '',
      factureFileName: '',
      autresFactures: [],
    };
    this.emailPattern = EMAIL_PATTERN;
    this.telephonePattern = TELEPHONE_PATTERN;
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.PRTV_DEPOT_FACTURE));

    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        //on arrive de la reclamation, donc on a toutes les etapes de la demande.
        if (!this.allAntennistesCalled && state.demande.data.accueilInterface2 !== undefined) {
          this.getAllAntennisteListUntilResult(state.demande.data.numeroAnfr, MINUMUM_DISTANCE);
        }
        //on arrive de la recherche du suivi, donc on a aucune etape de la demande.
        if (!this.allAntennistesCalled && state.demande.data.codeStatut === 'PRTV_DE_EN_COURS_SAISIE_PAR_LE_TSP' &&
        state.demande.data.accueilInterface2 === undefined) {
          this.getAllAntennisteListUntilResult(state.demande.data.numeroAnfr, MINUMUM_DISTANCE);
        }
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          data: state.demande.data.prtvDepotFacture ? state.demande.data.prtvDepotFacture.asMutable({deep: true}) : this.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier :
            state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom :
            state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom :
            state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : '',
          checkCode: state.demande.data ? state.demande.data.checkCode : '',
          numeroAnfr: state.demande.data ? state.demande.data.numeroAnfr : ''
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
    this.disableNext = true;

    //angular prend pas de ng-change sur un file alors :
    this.$scope.factureFileChanged = (input) => {
      try {
        const file = input.files[0];
        this.updateFactureFile(file);
        this.$scope.$apply();
      } catch (error) {
        this.data.factureFileName = '';
        this.data.factureFile = '';
      }
    };

    this.$scope.otherFileChanged = (input) => {
      this.tempFilename = input.name;
      this.$scope.$apply();
    };
  }

  updateFactureFile(file) {
    this.convertFileToBase(file).then(convertedFile => {
      if (file instanceof Blob) {
        this.data.factureFile = convertedFile;
        this.data.factureFileName = file.name;
        document.getElementById('removableFacture').style.display = 'block';
        this.$scope.$apply();
      } else {
        this.onClickRemoveFactureFile();
      }
    });
  }

  updateTempFile(file, id) {
    if (file !== undefined) {
      this.convertFileToBase(file).then(convertedFile => {
        if (file instanceof Blob) {
          this.tempFile = convertedFile;
          this.tempFilename = file.name;
          let obj = {
            binary: convertedFile,
            name: file.name,
            id: id
          };
          this.data.autresFactures.push(obj);
          this.$scope.$apply();
        }
      });
    }
  }

  getAllAntennisteListUntilResult(numeroAnfr, rayonMax) {
    if (this.fetching) {
      return;
    }
    if (numeroAnfr === undefined) {
      return;
    }
    //on passe a true au premier appel, pour qu'on ne rappelle pas apres sans avoir modifié la distance.
    this.allAntennistesCalled = true;
    this.loadingWebService = true;
    ListeAntennisteRepository.getAntennisteList(numeroAnfr, rayonMax)
    .then((response) => {
      if (response.total > 0) {
        this.allAntennistes = response;
        this.nbOfAntennistes = response.data.length;
        this.rayonMax = rayonMax;
        this.loadingWebService = false;
      } else {
        let nouveauRayon = rayonMax + DISTANCE_STEP;
        if (nouveauRayon < MAXIMUM_DISTANCE) {
          this.getAllAntennisteListUntilResult(numeroAnfr, nouveauRayon);
        }
      }
    });
  }

  onChangeRayonMax() {
    let temp = this.rayonMax;
    let changement = new Date();
    setTimeout(() => {
      //si le rayon courant est le dernier rayon modifié, et qu'il est different du dernier rayon envoyé
      if (temp === this.rayonMax && temp !== this.lastRayon) {
        //si le changement date de plus d'une seconde
        if (Math.abs(changement.getTime() - this.dernierChangementRayon.getTime()) > 1000) {
          this.loadingWebService = true;
          this.dernierChangementRayon = new Date();
          ListeAntennisteRepository.getAntennisteList(this.demande.numeroAnfr, temp).then(
          (response) => {
            if (typeof response.data !== 'undefined') {
              this.allAntennistes = response;
              this.nbOfAntennistes = response.data.length;
              this.lastRayon = temp;
              this.loadingWebService = false;
            }
          });
        }
      }
    }, 1000);
  }

  onClickRemoveFactureFile() {
    this.data.factureFile = '';
    this.data.factureFileName = '';
    this.data.autresFactures = [];
    document.getElementById('factureFile').value = '';
    document.getElementById('removableFacture').style.display = 'none';
  }

  convertFileToBase(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = () => {
        reject('');
      };
    });
  }

  onClickAddOtherFile() {
    try {
      const file = document.getElementById('otherFile').files[0];
      const id = new Date().toISOString();
      this.updateTempFile(file, id);
      document.getElementById('otherFile').value = null;
    } catch (error) {
      console.error(error, 'Erreur lors du téléchargement de votre fichier');
    }
  }

  download() {
    PdfUtil.openPdfUrl(this.numeroAnfr, this.checkCode, false);
    this.pdfurl = PdfUtil.buildPdfUrl(this.numeroAnfr, this.checkCode, false);
  }

  onClickRemoveOtherFiles(e) {
    this.data.autresFactures = this.data.autresFactures.filter(file => file.id !== e.target.getAttribute('deleteId'));
  }

  checkDuplicatesFiles() {
    if (this.data.autresFactures.length > 0) {
      let tab = JSON.parse(JSON.stringify(this.data.autresFactures));
      //ajoute la première facture pour comparer les doublons avec tous les fichiers
      tab.unshift(
        {
          binary: this.data.factureFile,
          name: this.data.factureFileName,
          id: 'facture'
        });
      const uniqueNamesArray = tab.filter((file, index, array) => {
        return index === array.findIndex(files => files.name === file.name);
      });
      // retire le premier fichier,
      uniqueNamesArray.shift();
      // update les fichiers
      this.data.autresFactures = uniqueNamesArray;
    }
  }

  // Actions
  nextStep() {
    this.checkDuplicatesFiles();
    if (this.data.factureFile !== '') {
      this.$ngRedux.dispatch(DemandeActions.updatePrtvDepotFacture(this.data));
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/prtv/components/prtv-depot-facture/prtv-depot-facture.component.js